import { ConceptDetailsResponse } from "catalog/types/interfaces/conceptResponse";
import queryString from "query-string";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CONCEPT_API } = import.meta.env;

const useConceptDetails = (conceptId?: string) =>
  useFetcher<ConceptDetailsResponse>(
    conceptId ? `${VITE_CONCEPT_API}/analysis/${conceptId}` : null
  );

export const useConceptDetailsMulti = (conceptIds: string[]) => {
  const qs = queryString.stringify({ concept_ids: conceptIds });
  return useFetcher<{ responses: ConceptDetailsResponse[] }>(
    conceptIds?.length ? `${VITE_CONCEPT_API}/analysis/multiple?${qs}` : null
  );
};

export default useConceptDetails;
